import {REWARD_CONSUME_START, REWARD_CONSUME_SUCCESS, REWARD_CONSUME_FAIL, REWARD_CONSUME_RESET} from './constants';
import {RewardConsumeActions, RewardConsumeState} from './types';

const initialState: RewardConsumeState = {
  loading: false,
  data: undefined,
  error: undefined,
};

const reducer = (
  state = initialState,
  action: RewardConsumeActions,
): RewardConsumeState => {
  switch (action.type) {
    case REWARD_CONSUME_START:
      return {
        ...initialState,
        loading: true,
      };
    case REWARD_CONSUME_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case REWARD_CONSUME_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      };
    case REWARD_CONSUME_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
